import { axios } from "../../config/axios";

export const beeAPI = {
  /**
   * Delete a specific email template
   * @param {Number} templateId Template Id
   * @returns status code
   */
  deleteEmailTemplate(templateId){
    return axios.delete(`/api/v3/email_templates/${templateId}`)
                .then(resp => resp)
                .catch(error => error.response);
  },
  /**
   * Get Authentication Token from Bee
   * @returns {Object} Token Object
   */
  getAuthToken() {
    return axios.get("/api/v3/email_templates/bee_access_token")
                .then((resp) => resp.data);
  },
  /**
   * Get all email templates
   * @param {Number} communicationId Communication Id
   * @returns {Object} Global templates (array), specific merchant template (array), specific campaign template (object)
   */
  getEmailTemplates(communicationId) {
    return axios.get("/api/v3/email_templates/available_templates", {
                    params: {
                      campaign_id: communicationId
                    }
                })
                .then(resp => resp.data);
  },
  /**
   * Update email template
   * @param {Number} campaignId
   * @param {String} jsonLayout
   * @param {String} htmlLayout
   * @returns {Object} Email template
   */
  putUpdateEmailTemplate(campaignId, jsonLayout, htmlLayout) {
    return axios.patch("/api/v3/email_templates/update_email_template", {
                  campaign_id: campaignId,
                  layout_json: jsonLayout,
                  layout_html: htmlLayout
                })
                .then(resp => resp.data);
  },
  /**
   * Create merchant specific email template
   * @param {String} jsonLayout
   * @param {String} [title="merchant created template - ###"] - title given to the template, default title if none provided
   * @returns status code
   */
  postCreateMerchantEmailTemplate(jsonLayout, title) {
    return axios.post("/api/v3/email_templates/create_merchant_email_template", {
                  layout_json: jsonLayout,
                  title: title
                })
                .then(resp => resp);
  }
}